define.alias("shared/components/shared/credentials/instagram-auth-status", "media/components/shared/credentials/instagram-auth-status");